import React, { useEffect, useState } from 'react';
import SubscriptionList from 'components/Payments/SubscriptionList';
import CreditCardList from 'components/Patient/CreditCardList';
import DefaultButton from 'components/Utils/NewDefaultButton';
import ReceiptList from 'components/Payments/ReceiptList';
import SubscriptionUtils from 'services/SubscriptionUtils';
import DefaultModal from 'components/Utils/DefaultModal';
import SubscribeScreen from 'components/Payments/SubscribeScreen';
import './style.scss';
import PatientUtils from 'services/PatientUtils';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';
import StripeUtils from 'services/StripeUtils';

const DEFAULT_ARRAY = [];

const PatientBilling = ({ patient }) => {
  const dispatch = useAppDispatch();
  const patientId = patient.id;

  const creditCards =
    useAppSelector((state) => state.payments.creditCards[patient.id]) || DEFAULT_ARRAY;

  const stripeEnabled = StripeUtils.isEnabled();

  useEffect(() => {
    if (stripeEnabled) {
      dispatch(api.Payments.getCreditCards({ patientId }));
    }
  }, [dispatch, patientId, stripeEnabled]);

  if (!stripeEnabled) {
    return (
      <div className="scroll-list full-height full-width">
        <p>Billing is not available for this clinic.</p>
      </div>
    );
  }

  return (
    <div className="full-width section-cards-layout">
      <div className="section">
        <SubscriptionList patient={patient} key={'subscription-list-' + patient.id} />
      </div>
      <div className="section">
        <CreditCardList
          patient={patient}
          key={'card-list-' + patient.id}
          creditCards={creditCards}
        />
      </div>
      <div className="section">
        <span className="small-title">Receipts</span>
        <ReceiptList patient={patient} key={'receipt-list-' + patient.id} />
      </div>
    </div>
  );
};

export default PatientBilling;
